import { TicketingFormCategory } from "@simplyk/common";

import { Translate } from "@/common/hooks/useTranslate";

export interface StepQuestionsV4Wording {
  title: string;
  buyerSectionTitle: string;
  buyerSectionTooltip?: string;
  addBuyerQuestionLabel: string;
  buyerToggleLabel: string;
  buyerModalTitle: string;
  attendeeSectionTitle: string;
  attendeeSectionTooltip?: string;
  attendeeSectionEmpty: string;
  addAttendeeQuestionLabel: string;
  attendeeToggleLabel: string;
  attendeeModalTitle: string;
  isBuyerSectionFirst: boolean;
}

export const getStepQuestionsV4Wording = (
  t: Translate,
  formCategory: TicketingFormCategory = TicketingFormCategory.Event
): StepQuestionsV4Wording => {
  const buyerOnly = {
    buyerSectionTitle: t("dashboard", "stepQuestionsV4.section.buyerOnly"),
    addBuyerQuestionLabel: t("dashboard", "stepQuestionsV4.addBuyerOnlyQuestion"),
    buyerToggleLabel: t("dashboard", "stepQuestionsV4.dialog.buyerOnlyToggle"),
    buyerModalTitle: t("dashboard", "stepQuestionsV4.dialog.buyerOnlyTitle"),
  };

  switch (formCategory) {
    case TicketingFormCategory.MembershipV2:
      return {
        title: t("dashboard", "stepQuestionsV4.title.membership"),
        buyerSectionTitle: t("dashboard", "stepQuestionsV4.section.buyer"),
        buyerSectionTooltip: t("dashboard", "stepQuestionsV4.section.buyer.tooltip"),
        addBuyerQuestionLabel: t("dashboard", "stepQuestionsV4.addBuyerQuestion"),
        buyerToggleLabel: t("dashboard", "stepQuestionsV4.dialog.buyerToggle"),
        buyerModalTitle: t("dashboard", "stepQuestionsV4.dialog.buyerTitle"),
        attendeeSectionTitle: t("dashboard", "stepQuestionsV4.section.member"),
        attendeeSectionEmpty: t("dashboard", "stepQuestionsV4.section.member.empty"),
        addAttendeeQuestionLabel: t("dashboard", "stepQuestionsV4.addMemberQuestion"),
        attendeeToggleLabel: t("dashboard", "stepQuestionsV4.dialog.memberToggle"),
        attendeeModalTitle: t("dashboard", "stepQuestionsV4.dialog.memberTitle"),
        isBuyerSectionFirst: false,
      };
    case TicketingFormCategory.Shop:
      return {
        ...buyerOnly,
        title: t("dashboard", "stepQuestionsV4.title.shop"),
        attendeeSectionTitle: t("dashboard", "stepQuestionsV4.section.item"),
        attendeeSectionTooltip: t("dashboard", "stepQuestionsV4.section.item.tooltip"),
        attendeeSectionEmpty: t("dashboard", "stepQuestionsV4.section.item.empty"),
        addAttendeeQuestionLabel: t("dashboard", "stepQuestionsV4.addItemQuestion"),
        attendeeToggleLabel: t("dashboard", "stepQuestionsV4.dialog.itemSoldToggle"),
        attendeeModalTitle: t("dashboard", "stepQuestionsV4.dialog.itemTitle"),
        isBuyerSectionFirst: true,
      };
    case TicketingFormCategory.Sweepstakes:
      return {
        ...buyerOnly,
        buyerSectionTitle: t("dashboard", "sweepstakes.questions.buyerSection"),
        title: t("dashboard", "sweepstakes.questions.title"),
        attendeeSectionTitle: t("dashboard", "sweepstakes.questions.entrySection"),
        attendeeSectionTooltip: t("dashboard", "sweepstakes.questions.entrySection.tooltip"),
        attendeeSectionEmpty: t("dashboard", "sweepstakes.questions.entrySection.empty"),
        addAttendeeQuestionLabel: t("dashboard", "sweepstakes.questions.addEntryQuestion"),
        attendeeToggleLabel: t("dashboard", "sweepstakes.questions.entryToggle"),
        attendeeModalTitle: t("dashboard", "sweepstakes.questions.entryModalTitle"),
        isBuyerSectionFirst: true,
      };
    case TicketingFormCategory.Lottery:
      return {
        ...buyerOnly,
        title: t("dashboard", "stepQuestionsV4.title.raffle"),
        attendeeSectionTitle: t("dashboard", "stepQuestionsV4.section.ticket"),
        attendeeSectionTooltip: t("dashboard", "stepQuestionsV4.section.ticket.tooltip"),
        attendeeSectionEmpty: t("dashboard", "stepQuestionsV4.section.ticket.empty"),
        addAttendeeQuestionLabel: t("dashboard", "stepQuestionsV4.addTicketQuestion"),
        attendeeToggleLabel: t("dashboard", "stepQuestionsV4.dialog.ticketSoldToggle"),
        attendeeModalTitle: t("dashboard", "stepQuestionsV4.dialog.ticketTitle"),
        isBuyerSectionFirst: true,
      };
    case TicketingFormCategory.Auction:
      return {
        title: t("dashboard", "stepQuestionsV4.title.auction"),
        buyerSectionTitle: t("dashboard", "stepQuestionsV4.section.bidderOnly"),
        addBuyerQuestionLabel: t("dashboard", "stepQuestionsV4.addBidderOnlyQuestion"),
        buyerToggleLabel: t("dashboard", "stepQuestionsV4.dialog.bidderOnlyToggle"),
        buyerModalTitle: t("dashboard", "stepQuestionsV4.dialog.bidderOnlyTitle"),
        attendeeSectionTitle: t("dashboard", "stepQuestionsV4.section.auctionItem"),
        attendeeSectionTooltip: t("dashboard", "stepQuestionsV4.section.auctionItem.tooltip"),
        attendeeSectionEmpty: t("dashboard", "stepQuestionsV4.section.item.empty"),
        addAttendeeQuestionLabel: t("dashboard", "stepQuestionsV4.addItemQuestion"),
        attendeeToggleLabel: t("dashboard", "stepQuestionsV4.dialog.itemToggle"),
        attendeeModalTitle: t("dashboard", "stepQuestionsV4.dialog.itemTitle"),
        isBuyerSectionFirst: true,
      };
    case TicketingFormCategory.Event:
    case TicketingFormCategory.Custom:
      return {
        ...buyerOnly,
        title: t("dashboard", "stepQuestionsV4.title"),
        attendeeSectionTitle: t("dashboard", "stepQuestionsV4.section.attendee"),
        attendeeSectionTooltip: t("dashboard", "stepQuestionsV4.section.attendee.tooltip"),
        attendeeSectionEmpty: t("dashboard", "stepQuestionsV4.section.attendee.empty"),
        addAttendeeQuestionLabel: t("dashboard", "stepQuestionsV4.addAttendeeQuestion"),
        attendeeToggleLabel: t("dashboard", "stepQuestionsV4.dialog.attendeeToggle"),
        attendeeModalTitle: t("dashboard", "stepQuestionsV4.dialog.attendeeTitle"),
        isBuyerSectionFirst: false,
      };
  }
};
